import { ContextualInfoButton, ContextualInfoButtonWithText } from "@/components/buttons/ContextualInfoButton";
import { getHazardColor, getHazardIcon } from "@/features/branding";
import { availableExposureHazards, ExposuresByHazard, getExposureStatusLabel, getReturnPeriodLabel, hazardToDisplayName, ReturnPeriod } from "@/features/pe_aldd";
import type { ExposureStatus } from "@/types/exposure";
import { AnaHazardId } from "@/store/services/facades/types";
import { Table } from "antd";
import { useEffect, useState } from "react";
type ScreeningHazardExposureItem = {
  hazard: AnaHazardId;
  returnPeriod: ReturnPeriod;
  exposureStatus: ExposureStatus | null;
  disabled?: boolean;
};
const columns = [{
  key: "hazardType",
  title: "Climate Hazard",
  dataIndex: "hazard",
  render: (hazard: AnaHazardId) => <div className="flex items-center gap-2">
        {getHazardIcon(hazard, {
      style: {
        color: getHazardColor(hazard)
      }
    })}
        {hazardToDisplayName(hazard)}
      </div>
}, {
  key: "returnPeriod",
  title: <div className="flex items-center gap-1">
        Return Period
        <ContextualInfoButton className="!mt-[1px] !text-sm" id="returnPeriod" />
      </div>,
  dataIndex: "returnPeriod",
  render: (returnPeriod: ReturnPeriod) => getReturnPeriodLabel(returnPeriod, false)
}, {
  key: "exposureStatus",
  title: "Flood Exposure",
  dataIndex: "exposureStatus",
  render: (exposureStatus: ExposureStatus) => getExposureStatusLabel(exposureStatus)
}];
const ScreeningHazardExposures = ({
  hideTitle = false,
  exposure,
  displayReturnPeriod,
  limitReturnPeriods
}: {
  hideTitle?: boolean;
  limitReturnPeriods: ReturnPeriod[];
  displayReturnPeriod: ReturnPeriod;
  exposure: ExposuresByHazard | undefined;
}) => {
  const [data, setData] = useState<ScreeningHazardExposureItem[]>([]);
  useEffect(() => {
    if (exposure === undefined || exposure === null) {
      setData([]);
      return;
    }
    const hazardExposureData = limitReturnPeriods.flatMap(rp => availableExposureHazards.map(hazard => ({
      disabled: rp !== displayReturnPeriod,
      hazard,
      returnPeriod: rp,
      exposureStatus: exposure[hazard]?.[rp] ?? null
    })));
    setData(hazardExposureData);
  }, [displayReturnPeriod, exposure]);
  return <>
      {!hideTitle && <ContextualInfoButtonWithText rootClassName="text-base font-semibold mb-4" id="exposure">
          Flood Exposure
        </ContextualInfoButtonWithText>}

      <Table size="small" pagination={false} columns={columns} dataSource={data} locale={{
      emptyText: `Exposure data not found.`
    }} rowClassName={row => row?.disabled ? "opacity-20 pointer-events-none" : ""} data-sentry-element="Table" data-sentry-source-file="ScreeningHazardExposures.tsx" />
    </>;
};
export default ScreeningHazardExposures;